import { render, staticRenderFns } from "./ListObligations.vue?vue&type=template&id=785d2410"
import script from "./ListObligations.vue?vue&type=script&lang=js"
export * from "./ListObligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports